import { ModelOption } from "./types";
import { AdvancedOptions } from "../services/ttsService";

export const ALL_MODELS: ModelOption[] = [
  { value: "", label: "All models" },
  { value: "Chirp3-HD", label: "Chirp 3 HD (best)" },
  { value: "Neural2", label: "Neural2 (natural)" },
  { value: "Studio", label: "Studio (expressive)" },
  { value: "Polyglot", label: "Polyglot (multilingual)" },
  { value: "WaveNet", label: "WaveNet" },
  { value: "Standard", label: "Standard" },
];

export const AUDIO_ENCODINGS: AdvancedOptions["audioEncoding"][] = ["MP3", "LINEAR16", "OGG_OPUS"];

export const EFFECTS_PROFILES = [
  { value: "", label: "None" },
  { value: "wearable-class-device", label: "Wearable" },
  { value: "handset-class-device", label: "Handset (phone)" },
  { value: "headphone-class-device", label: "Headphone" },
  { value: "small-bluetooth-speaker-class-device", label: "Small BT speaker" },
  { value: "medium-bluetooth-speaker-class-device", label: "Medium BT speaker" },
  { value: "large-home-entertainment-class-device", label: "Home entertainment" },
  { value: "large-automotive-class-device", label: "Automotive" },
];